/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryOrder } from '../../models/delivery-order';

export interface CreateDeliveryOrder$Params {
      body: DeliveryOrder
}

export function createDeliveryOrder(http: HttpClient, rootUrl: string, params: CreateDeliveryOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryOrder>> {
  const rb = new RequestBuilder(rootUrl, createDeliveryOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryOrder>;
    })
  );
}

createDeliveryOrder.PATH = '/delivery-orders';
